import {i18n} from "../../plugins/vue-i18n";

export default class UnitOfMeasure{
  constructor(item){
    this.code = item.code;
    this.name = i18n.t("CONTENT." + item.code);
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create UnitOfMeasure from data if data is null.");
    return new UnitOfMeasure(data);
  }
}
